import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsUsNearlyPage from "../ListVpsUsNearlyPage";

const PageListVpsUsNearly = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps-us/chuyen-khach-hang.html?' + listVps);
    }

    return <ListVpsUsNearlyPage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
    />

}

export default PageListVpsUsNearly;